import * as types from "./types";

export const fetchingCommitment = () => ({
  type: types.FETCHING_COMMITMENT,
  loading: true
});

export const signingCommitment = () => ({
  type: types.SIGNING_COMMITMENT,
  loading: true
});

export const signedCommitment = (commitment, circleId) => ({
  type: types.SIGNED_COMMITMENT,
  commitment: commitment,
  circleId: circleId,
  loading: false
});

export const fetchedCommitment=(commitments, circleId)=>({
  type: types.FETCHED_COMMITMENT,
  commitments: commitments,
  circleId: circleId,
  loading: false
});

export const errorFetchingCommitment = (error) => ({
  type: types.ERROR_FETCHING_COMMITMENT,
  error: error,
  loading: false
});